export default __webpack_public_path__ + "static/media/python_logo.f0c9d647.png";